import app from 'flarum/forum/app';
const byPosition = (a, b) => (a.position() ?? 0) - (b.position() ?? 0);

/** Forum sections (primary tags without a parent), in admin order. */
export function sections() {
  return app.store.all('tags').filter(tag => tag.position() !== null && !tag.isChild()).sort(byPosition);
}

/** Subsections of a section, in admin order. */
export function subsections(section) {
  return app.store.all('tags').filter(tag => tag.isChild() && tag.parent() === section).sort(byPosition);
}

/** Section number as on the portal: 01, 02 … */
export function sectionNumber(section) {
  return String((section.position() ?? 0) + 1).padStart(2, '0');
}
export function sectionOf(tag) {
  return tag.isChild() && tag.parent() || tag;
}

/** The section and subsection a discussion is filed under. */
export function discussionPlacement(tags) {
  const subsection = tags.find(tag => tag.isChild());
  const section = subsection ? subsection.parent() : tags.find(tag => tag.position() !== null);
  return {
    section,
    subsection
  };
}

/** Section of the page being viewed: a tag page, or the discussion being read. */
export function activeSection() {
  const tag = app.currentTag?.();
  if (tag) return sectionOf(tag);
  const discussion = app.current.get('discussion');
  const tags = discussion?.tags?.() || [];
  return discussionPlacement(tags).section;
}
flarum.reg.add('tarotportal-theme', 'forum/utils/sections', { sections: sections,subsections: subsections,sectionNumber: sectionNumber,sectionOf: sectionOf,discussionPlacement: discussionPlacement,activeSection: activeSection, });